import Image from "next/image";

import { cn } from "@/src/lib/utils";
import { Heading, Text } from "@/src/components/ui/Typography";

import type { TestimonialItemData } from "./TestimonialCard.types";

interface TestimonialMobileRowProps {
  item: TestimonialItemData;
  index: number;
  open: boolean;
  onToggle: () => void;
}

export function TestimonialMobileRow({ item, index, open, onToggle }: TestimonialMobileRowProps) {
  return (
    <div className="border-b border-neutral-200 py-6 first:pt-0 last:border-b-0">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-start gap-4 text-left"
      >
        <Text as="span" size="labelMD" className="mt-1 w-4 shrink-0 text-neutral-400">
          {index}
        </Text>

        <div className="min-w-0 flex-1">
          <div
            className={cn(
              "grid overflow-hidden transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]",
              open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
            )}
          >
            <div className="min-h-0 overflow-hidden">
              <div className="flex items-center gap-3">
                {item.avatarSrc && (
                  <Image
                    src={item.avatarSrc}
                    alt={item.name}
                    width={44}
                    height={44}
                    className="size-11 shrink-0 rounded-full object-cover"
                  />
                )}

                <div>
                  <Heading as="h3" size="headingMD" className="text-neutral-700">
                    {item.name}
                  </Heading>

                  <Text size="bodySM" className="text-neutral-500">
                    {item.role}
                  </Text>
                </div>
              </div>

              <Text
                as="div"
                size="bodySM"
                className="mt-4 text-neutral-600 [&_p]:mb-2 [&_p:last-child]:mb-0 [&_h2]:mt-2 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-neutral-700 [&_h3]:mt-2 [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:text-neutral-700 [&_strong]:text-neutral-700 [&_a]:text-brand [&_a]:underline [&_pre]:mt-2 [&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:bg-neutral-100 [&_pre]:p-3 [&_pre]:text-xs"
                dangerouslySetInnerHTML={{ __html: item.quoteHtml }}
              />
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}
